import React, { useEffect, useState, useRef, use } from "react";
import { Form, Row, InputGroup, Button, Col } from "react-bootstrap";
import Head from "next/head";
import { appServerSideProps } from "../../utils/getAppService";
import Link from "next/link";
import Utils from "../../utils/Utils";
import { authGetRequest, getRequest } from "../../utils/authGetRequest";
import MainLayout from "../../components/MainLayout/MainLayout";
import ValueBracket from "../../assets/images/ValueBracket.png";
import Bracket from "../../components/Bracket";
import { useCookies } from "react-cookie";
import MarchMadnessLatestPosts from "../../components/MarchMadnessLatestPosts";
import { getAllWpPostQuery } from "../blog";
import { useQuery } from "@apollo/client";
import Input from "../../components/form/Input";
import { AiOutlineMail } from "react-icons/ai";
import ContentfulBlogs from "../../components/contentfulBlogs/ContentfulBlogs";
import { getDefYear } from "../../constants/main";

const ValueBrackets = ({ user }) => {
  const [isValid, setIsValid] = useState(false);
  const [cookies, setCookie] = useCookies(["marchmadness_subscribed"]);
  const [marchmadnessSubscribed, setMarchmadnessSubscribed] = useState(false);
  const [bracketType, setBracketType] = useState("model");
  const [valueBracketData, setValueBracketData] = useState(null);
  const [modelBracketData, setModelBracketData] = useState(null);
  // const { loading, error, data } = useQuery(getAllWpPostQuery);

  const [authToken, setAuthToken] = useState(null);
  const [emailAddress, setEmailAddress] = useState("");
  const [bracketsData, setBracketsData] = useState(null);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  useEffect(() => {
    setIsValid(validateEmail(emailAddress));
  }, [emailAddress]);

  const handleSubmit = () => {
    if (isValid) {
      fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/klaviyo/march_madness/${emailAddress}/save`)
        .then((res) => {
          if (res.status === 200) {
            setCookie("marchmadness_subscribed", true, {
              maxAge: 31536000,
              path: "/",
            });
            setMarchmadnessSubscribed(true);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };
  useEffect(() => {
    if (cookies.token_access) {
      setAuthToken(cookies.token_access);
    }
  }, []);

  useEffect(() => {
    if (bracketType === "value") {
      setBracketsData(valueBracketData);
    } else {
      setBracketsData(modelBracketData);
    }
  }, [bracketType, valueBracketData, modelBracketData]);

  const getBrackets = () => {
    if (marchmadnessSubscribed || authToken) {
      getRequest(`/api/${getDefYear("college_mens")}/bracket`)
        // getRequest(`/api/2024/bracket`)
        .then((response) => response.data)
        .then((response) => {
          Utils.readCsv("teams/Color_Code_for_Teams.csv").then((colorCSV) => {
            let colorCodesMapped = response.data.map((dt) => {
              return {
                ...dt,
                Team_1_Color: colorCSV.filter((x) => x.Teams == dt["Team 1"])[0].Colors,
                Team_2_Color: colorCSV.filter((x) => x.Teams == dt["Team 2"])[0].Colors,
              };
            });
            // setBracketsData(colorCodesMapped);
            setValueBracketData(colorCodesMapped);
          });
        })
        .catch((err) => {
          console.log(err);
        });
      getRequest(`/api/${getDefYear("college_mens")}/model_bracket`)
        .then((response) => response.data)
        .then((response) => {
          Utils.readCsv("teams/Color_Code_for_Teams.csv").then((colorCSV) => {
            let colorCodesMapped = response.data.map((dt) => {
              return {
                ...dt,
                Team_1_Color: colorCSV.filter((x) => x.Teams == dt["Team 1"])[0].Colors,
                Team_2_Color: colorCSV.filter((x) => x.Teams == dt["Team 2"])[0].Colors,
              };
            });
            setModelBracketData(colorCodesMapped);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    setMarchmadnessSubscribed(cookies.marchmadness_subscribed);
    getBrackets();
  }, [cookies.marchmadness_subscribed, authToken]);

  const handleBracketElementClick = (data) => {
    console.log("test ");
    // setShowBracketModal(true);
    // setShowActiveBracketData(data);
  };

  const handleDownloadBracket = () => {
    const link = "https://rcl.ink/LZPQe";
    window.open(link, "_blank");
  };

  const handlePrintSection2 = () => {
    console.log("Print button clicked"); // Debugging log
    const printContent = document.querySelector(".print-this-section");
    if (!printContent) {
      console.error("Element with class 'print-this-section' not found");
      return;
    }
    console.log("Print content found:", printContent); // Debugging log

    const newWindow = window.open("", "_blank");
    if (!newWindow) {
      console.error("Failed to open a new window");
      return;
    }
    newWindow.document.write(`
      <html>
        <head>
          <title>Print Bracket</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };
  const handlePrintSection = () => {
    console.log("Print button clicked"); // Debugging log
    const printContent = document.querySelector(".print-this-section");
    if (!printContent) {
      console.error("Element with class 'print-this-section' not found");
      return;
    }

    // Add a title or name to the printed content
    const printTitle = `<h1 style="text-align: center; margin-bottom: 20px;">ShotQuality ${
      bracketType === "model" ? "Model" : "Value"
    } Bracket</h1>`;
    const printContentHTML = printTitle + printContent.innerHTML;

    // Backup the original content
    const originalContent = document.body.innerHTML;

    // Replace the body content with the section to print
    document.body.innerHTML = printContentHTML;

    // Trigger the print dialog
    window.print();

    // Restore the original content after printing
    document.body.innerHTML = originalContent;
    window.location.reload(); // Reload the page to reinitialize scripts
  };
  return (
    <>
      <Head>
        <title>NCAA Basketball Teams: Odds, Predictions Spreads & More | ShotQuality</title>
        <meta
          name="description"
          content="Explore every NCAA basketball team to easily find odds, predictions, spreads, picks and parlays, and more. ShotQuality
          Bets provides the most accurate, robust and predictable dataset for NCAA college basketball odds, picks and parlays. Access our dataset now to
          unlock all NCAAB odds and easily identify points-of-value for each game."
        />
      </Head>
      <MainLayout>
        <div style={{ padding: "0 3.5%" }}>
          <main id="ContentBox" style={{ minHeight: "100vh" }}>
            <div className="MiscStats ValueBracket">
              {/* Start Title side */}
              <div className=" text-center">
                <div>
                  <div className="dukescroe">
                    <div className="row align-items-center header-container">
                      <div className="box col-md-8 text-md-left ValueBracketTitle">
                        <h2>ShotQuality {bracketType === "model" ? "Model" : "Value"} Bracket</h2>
                        {bracketType === "model" ? (
                          <div className="text-black fs-4 fw-5 pb-5 pt-3 mb-5">
                            We use our ShotQuality pregame predictive model to predict every potential matchup in the
                            tournament, powered by over 50 million data points. Here's what we have:
                          </div>
                        ) : (
                          <div className="text-black fs-4 fw-5">
                            We use predictive analytics powered by over 50 million data points to highlight value
                            opportunities for your March Madness bracket. This bracket analyses the percentage of NCAA
                            fans who picked the winner against ShotQuality's winning percentage to show picks that have
                            maximum value. Here are the parameters:
                            <ul className="mt-3">
                              <li>
                                If there's a 20% difference between SQ Predicted Outcome and People's Bracket Outcome,
                                we go with the value pick to maximize bracket points.
                                <ul>
                                  <li>
                                    {`Caveat: If we predict a team will win (>50% chance) their Round of 64 matchup but
                                    they are not the majority team publicly, we pick the team we think will win.`}
                                  </li>
                                </ul>
                              </li>
                              <li>
                                {`If we estimate a team has > 65% chance of winning, they advance regardless of value
                                relative to public.`}
                              </li>
                              <li>
                                In later rounds, in the absence of public pick data for both teams, we pick the team we
                                expect to win.
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                      {marchmadnessSubscribed || authToken ? (
                        <div className="box col-md-4 text-md-center">
                          {/* <button className="btn export-button px-4 p-3 m-3" onClick={handleDownloadBracket}> */}
                          <button className="btn export-button px-4 p-3 m-3" onClick={handlePrintSection}>
                            Download Bracket
                            <svg
                              style={{ marginLeft: "0.5rem" }}
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
                                stroke="#0F131B"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.83325 8.33337L9.99992 12.5L14.1666 8.33337"
                                stroke="#0F131B"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10 12.5V2.5"
                                stroke="#0F131B"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      ) : null}
                      {!marchmadnessSubscribed && !authToken ? (
                        <>
                          <div className="col-md-12 dummyLockWrapper">
                            <div className="imgWrapper">
                              <img src={ValueBracket.src} className="bracketBackground" alt="" />
                            </div>
                            <div
                              className="dummyLock"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                position: "absolute",
                                top: "20px",
                                left: "50%",
                                transform: "translateX(-50%)",
                              }}
                            >
                              <h3>Want to see more?</h3>
                              <p>
                                Unlock ShotQuality Matchups. To see all data on this page, please share with us your
                                email to get access.
                              </p>
                            </div>
                          </div>

                          <Col
                            xxl={4}
                            lg={6}
                            xl={4}
                            sm={6}
                            md={6}
                            xs={10}
                            className="mx-auto fluid mm-email-submit-col"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "-600px",
                              zIndex: 999999,
                            }}
                          >
                            <Input
                              className="w-100 input-search form-control mm-email-submit-input"
                              icon={<AiOutlineMail size={20} style={{ marginTop: "5px" }} />}
                              onChange={(e) => setEmailAddress(e.target.value)}
                              style={{
                                fontSize: "14px",
                                borderRadius: "8px",

                                border: "1px solid #ced4da",
                              }}
                              placeholder="Enter your email"
                              aria-label="Username"
                              aria-describedby="basic-addon1"
                            />
                            <Button
                              className="mm-email-submit-input-btn"
                              style={{
                                backgroundColor: "black",
                                color: "white",

                                padding: "5px 15px",
                              }}
                              disabled={!isValid}
                              onClick={() => handleSubmit()}
                            >
                              Get Access
                            </Button>
                          </Col>
                        </>
                      ) : null}
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-12 text-center">
                        <div style={{ background: "#0F131B", borderRadius: "10px" }} className="btn-group w-90">
                          <button
                            type="button"
                            className={`btn btn-lg btn-primary text-white value-finder-buttons-group p-10-15 ${
                              bracketType === "model" ? "active" : ""
                            }`}
                            value="model"
                            onClick={() => {
                              setBracketType("model");
                            }}
                          >
                            Model Bracket
                          </button>
                          <button
                            type="button"
                            className={`btn btn-lg btn-primary text-white value-finder-buttons-group p-10-15 ${
                              bracketType === "value" ? "active" : ""
                            }`}
                            value="value"
                            onClick={() => {
                              setBracketType("value");
                            }}
                          >
                            Value Bracket
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Title side */}
            </div>
            <div className="print-this-section">
              {(marchmadnessSubscribed || authToken) && bracketsData?.length ? (
                bracketsData?.length > 0 ? (
                  <Bracket data={bracketsData} onBlockClick={handleBracketElementClick} />
                ) : (
                  <Bracket data={bracketsData} onBlockClick={handleBracketElementClick} />
                )
              ) : null}
            </div>
            {/* <Row
              style={{
                backgroundColor: "#f3f4f6",
              }}
            >
              <p className="mm-predictions-header mb-5" style={{ marginLeft: "50px" }}>
                March Madness Predictions and Analysis
              </p>
              {data && <MarchMadnessLatestPosts posts={data.posts.posts.slice(0, 3)} />}
            </Row> */}
            <div className="container">
              <ContentfulBlogs user={user} tag="marchMadness" />
            </div>
          </main>
        </div>
      </MainLayout>
    </>
  );
};

export default ValueBrackets;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return { props: { user } };
});
